export { default } from './Boleto25PassoaPasso';
